import { RequestService } from '../../../../../common/services/RequestService';
import { API_POST_PROFILE_CREATE_AND_FILL } from '../../constants';
import { dataAdjustmentRequest } from './dataAdjustmentRequest';

export const addUserProfileRequest = async (payload, roleId, userId) => {
  return RequestService.post(
    API_POST_PROFILE_CREATE_AND_FILL,
    dataAdjustmentRequest(payload, roleId, userId)
  );
};
